"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _makeDecoratorDisplayName = _interopRequireDefault(require("reference-resolvers/lib/makeDecoratorDisplayName"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _ReferenceResolversContext = require("./ReferenceResolversContext");

var _withReferenceResolverContext = _interopRequireDefault(require("./withReferenceResolverContext"));

var ConnectReferenceResolvers = function ConnectReferenceResolvers(mapResolversToProps, Component) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var ConnectResolvers =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ConnectResolvers, _React$Component);

    function ConnectResolvers() {
      (0, _classCallCheck2.default)(this, ConnectResolvers);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConnectResolvers).apply(this, arguments));
    }

    (0, _createClass2.default)(ConnectResolvers, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            resolvers = _this$props.referenceResolverContext,
            forwardedRef = _this$props.forwardedRef,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["referenceResolverContext", "forwardedRef"]);
        return _react.default.createElement(Component, (0, _extends2.default)({
          ref: forwardedRef
        }, rest, mapResolversToProps(resolvers, rest)));
      }
    }]);
    return ConnectResolvers;
  }(_react.default.Component);

  ConnectResolvers.propTypes = (0, _extends2.default)({}, _ReferenceResolversContext.referenceResolverContextPropTypes, {
    forwardedRef: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.shape({
      current: _react.PropTypes.object
    })])
  });
  var ContextConnector = (0, _withReferenceResolverContext.default)(ConnectResolvers);
  ContextConnector.displayName = (0, _makeDecoratorDisplayName.default)('ConnectReferenceResolvers', Component);
  ContextConnector.WrappedComponent = Component;

  if (options.forwardRef) {
    var ForwardedRef = (0, _react.forwardRef)(function (props, ref) {
      return _react.default.createElement(ContextConnector, (0, _extends2.default)({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedRef.WrappedComponent = ContextConnector.WrappedComponent;
    return ForwardedRef;
  }

  return ContextConnector;
};

var _default = (0, _curry.default)(ConnectReferenceResolvers);

exports.default = _default;
module.exports = exports.default;